import type { App, Plugin } from 'vue'
import type { RouteLocationNormalized, RouteRecordNormalized } from 'vue-router'
import type { LocaleType } from '#/config'

import { centToYuan } from '@aomi/utils'

export function getRawRoute(route: RouteLocationNormalized): RouteLocationNormalized {
  if (!route) return route
  const { matched, ...opt } = route
  return {
    ...opt,
    matched: (matched
      ? matched.map((item) => ({
          meta: item.meta,
          name: item.name,
          path: item.path,
        }))
      : undefined) as RouteRecordNormalized[],
  }
}

export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any
  comp.install = (app: App) => {
    app.component(comp.name || comp.displayName, component)
    if (alias) {
      app.config.globalProperties[alias] = component
    }
  }
  return component as T & Plugin
}

export const delay = (timeDuration: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeDuration)
  })
}

/**
 * 格式化字符串 ’123456‘ => '123 456'
 * @param str 字符串
 * @param chunkNum 几个连续字符为一组
 * @param joinStr 连接符
 * @param filterStr 需要去除的字符
 * @returns
 */
export const strFormatter = (
  str: string,
  chunkNum: number,
  joinStr = ` `,
  filterStr = '',
): string => {
  return [...str]
    .filter((char) => char.trim() && char !== filterStr)
    .reduce((acc, cur, i) => {
      if (i !== 0 && i % chunkNum === 0) {
        return (acc += `${joinStr}${cur}`)
      }
      return (acc += cur)
    }, '')
}

export function amountFilter(val: number): number {
  if (!val) return 0
  if (typeof val !== 'number') return val
  return centToYuan(val)
}

export function currencyUnitFormat(cent: number) {
  const result = centToYuan(cent).toFixed(2)
  if (!Number.isNaN(result)) {
    return result
  } else {
    return 0
  }
}

/**
 * url中的参数组装成preOrder
 * @param query - url中的参数
 * @returns
 */
export function urlSearch2OrderParams(query: QueryParams): AppParams {
  const preOrder = JSON.stringify({
    orderParamStr: query.orderParamStr,
    appId: query.appId || '',
  })

  return {
    ...query,
    preOrder,
  }
}

export function getLocal(): LocaleType {
  return 'zh_TW'
}
